module.exports = __webpack_public_path__ + "img/C7B9A1_F8F1E4_EEE4D2_E4D8C4-256px.11b20e8a.png";